exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header-image{max-width:320px;margin:0 auto;width:50%}.header-image>img{max-width:px;width:100%}p.intro-text{text-align:center;max-width:320px;width:100%;margin:0 auto}.ui.accordion .title{font-family:Benton Sans Cond}td.dropdown-element{padding:5px!important}p.text-block{font-family:Georgia}.masthead-component.masthead-component+*>*>:first-child:before{height:30px}div.georgia{font-family:Georgia;font-size:1em}div.georgia>strong{font-family:Benton Sans Cond;font-weight:800}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./src/components/trump-header/css/trumpheader.css
// module id = 76
// module chunks = 0